import axios from 'axios'
import APP from '../config/app.config'
import ETC from '../config/etc.config'
import Util from '../utils/util'
// import QS from 'qs'
const etcInstance = axios.create({
  baseURL: APP.HTTP_URL,
  timeout: APP.HTTP_TIMEOUT,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-APP-ID': '2',
    'X-APP-VER': APP.VERSION
  }
  // transformRequest: [(data) => {
  //   data = QS.stringify(data)
  //   return data
  // }]
})
// etcInstance.defaults.headers.post[] = 'application/x-www-form-urlencoded'
// etcInstance.defaults.headers.post['X-APP-ID'] = '2'
// etcInstance.defaults.headers.post['X-APP-VER'] = APP.VERSION
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

etcInstance.interceptors.request.use(config => {
  console.log('%c request  url: ' + config.url + ' => params:', 'color: red', config.data)
  if (config.method === 'post') {
  // 请求前设置 token
    config.headers.post['X-APP-TOKEN'] = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN) || ''
    config.data = Util.json2formData(config.data)
  }
  // if (config.headers?.['Content-Type']) {
  //   config.headers.post['Content-Type'] = config.headers['Content-Type']
  // }
  console.log(config);
  return config
}, err => {
  return Promise.reject(err)
})

export default etcInstance
